import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-blogs8',
  templateUrl: './section-blogs8.component.html',
  styleUrls: ['./section-blogs8.component.css']
})
export class SectionBlogs8Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
